"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// COLORS
const brand = "#000000";
const headerBackgroundColor = brand;
const headerTextColor = "#FFFFFF";
const appAccentColor = brand;
const mainInfoLandscape = brand;
const mainInfoPortrait = headerTextColor;
const style = "normal";
const colorAppBar = "#000000";
const colorOnAppBar = "#FFFFFF";
const colorPrimary = "#000000";
const colorPrimaryDarker = "#000000";
const colorPrimaryLighter = "#cccccc";
const colorOnPrimary = "#FFFFFF";
const colorSecondary = "#000000";
const colorOnSecondary = "#FFFFFF";
const colorTiles = ["#000000", "#000000", "#000000"];
exports.default = {
    brand,
    mainInfoLandscape,
    mainInfoPortrait,
    headerBackgroundColor,
    headerTextColor,
    appAccentColor,
    style,
    colorAppBar,
    colorOnAppBar,
    colorPrimary,
    colorPrimaryDarker,
    colorPrimaryLighter,
    colorOnPrimary,
    colorSecondary,
    colorOnSecondary,
    colorTiles,
};
